import React, { useEffect, useState } from 'react';
import PrimaryButton from '../components/Students/PrimaryButton';
import useSettings from '../hooks/useSettings';

const AdminTab = () => {
  const { yellowTime, redTime, barcodeRescanTime, saveSettings } = useSettings();
  useEffect(() => {
    setSaveEnabled(false);
  }, [yellowTime, redTime]);
  const [saveEnabled, setSaveEnabled] = useState(false);
  const property = (idLabel: string, label: string, timeUnit: string, value: string, inputValue?: string | null) => {
    return (
      <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt className="text-sm font-medium text-gray-500">{label}</dt>

        <div className="flex">
          <input
            className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 rounded-md border p-0.5 border-gray-200 w-8 mr-4"
            id={idLabel}
            type="text"
            defaultValue={inputValue ? inputValue : value}
            onChange={(e) => onText(idLabel, e.target.value)}
          />
          <span>{timeUnit}</span>
        </div>
      </div>
    );
  };

  const onText = (setting: string, value: string) => {
    if (value.length === 0) {
      setSaveEnabled(false);
    } else if (setting === 'yellow_time' && value !== yellowTime) {
      setSaveEnabled(true);
    } else if (setting === 'red_time' && value !== redTime) {
      setSaveEnabled(true);
    } else if (setting === 'barcode_rescan_time' && value !== barcodeRescanTime) {
      setSaveEnabled(true);
    } else {
      if (
        (document.getElementById('yellow_time') as HTMLInputElement).value === yellowTime &&
        (document.getElementById('red_time') as HTMLInputElement).value === redTime &&
        (document.getElementById('barcode_rescan_time') as HTMLInputElement).value === barcodeRescanTime
      ) {
        setSaveEnabled(false);
      }
    }
  };

  const buttons = () => {
    return (
      <div className="flex flex-wrap mr-1 ml-1" style={{ gap: '2%' }}>
        <PrimaryButton
          onClick={() =>
            saveSettings(
              (document.getElementById('yellow_time') as HTMLInputElement).value,
              (document.getElementById('red_time') as HTMLInputElement).value,
              (document.getElementById('barcode_rescan_time') as HTMLInputElement).value,
            )
          }
          disabled={!saveEnabled}
          label="Save"
          style={{ flex: '49%' }}
        />
      </div>
    );
  };

  return (
    <div>
      <div className="flex mb-4">
        {/*<button className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded ml-auto"*/}
        {/*        onClick={() => {*/}
        {/*            alert('to be implemented');*/}
        {/*        }}*/}
        {/*>*/}
        {/*    Download Check-in logs*/}
        {/*</button>*/}
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg border mb-8">
        <div className="px-4 py-5 sm:px-6 flex justify-between">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">{'Settings'}</h3>
          </div>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:p-0 mb-4">
          <dl className="sm:divide-y sm:divide-gray-200">
            {property(
              'yellow_time',
              'Yellow warning time (minutes before session time where yellow warning will show)',
              'minutes',
              yellowTime || '',
            )}
            {property(
              'red_time',
              'Red warning time (minutes before session time where red warning will show)',
              'minutes',
              redTime || '',
            )}
            {property(
              'barcode_rescan_time',
              'Barcode rescan time (seconds that you must wait before you can scan the same barcode again)',
              'seconds',
              barcodeRescanTime || '',
            )}
            {buttons()}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default AdminTab;
